module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selected":"Selected","andMore":"and more"}}')
  delete Component.options._Ctor
}
